if (PJQ.app.module === PJQ.constants.modules.PJQSETTINGS) {
	PJQ.app.attachReadyEvent(function () {
		initSystemSettings(jQuery("#pjq-main"));
	});
}
// else if (PJQ.app.module === PJQ.constants.modules.APP) {
// 	PJQ.modules.pjqSettings = {
// 		routes: [
// 			{
// 				route: 'settings',
// 				name: 'settings',
// 				callback: function () {
// 					PJQ.app.initNavigator({
// 						activeItem: "settings"
// 					});
// 				}
// 			}
// 		]
// 	};
// 	PJQ.app.addRoutes(PJQ.modules.pjqSettings.routes);
// }